import m from "mithril"
import "oj-event"
import { getJSON } from "oj-ajax"
import { getRootElements } from "oj-dom-utils"
import { IShoppingcart_state } from "../pages/shoppingcart"

export const redirect = (url: string) =>
    window.location.assign(url)

export const getShoppingCart = async () =>
    JSON.parse(await getJSON<string>("/umbraco/surface/ShoppingCartsurface/GetShoppingCart/")) as IShoppingcart_state

export const createRange = (length: number) =>
    Array.from({ length }, (c, n) => n + 1)

export const sum = (total: number, num: number) =>
    total + num

export const getComponentData = (root: HTMLElement, removeInput?: boolean) => {
    const data = root.getAttribute(`data-value`)
    if (data) {
        try {
            return JSON.parse(data)
        }
        catch (err) {
            console.error(err)
            return data
        }
    }

    const valueId = root.getAttribute(`data-value-id`)
    if (valueId) {
        const input = document.getElementById(valueId) as HTMLInputElement
        if (input) {
            try {
                const v = JSON.parse(input.value)
                if (removeInput)
                    (input.parentNode as HTMLElement).removeChild(input)
                return { data: v, valueId }
            }
            catch (err) {
                return { value: input.value, valueId }
            }
        }
    }

    return null
}

export const injectStyleSheet = (src: string) => {
    const documentHead = document.head as HTMLHeadElement
    if (documentHead.querySelector(`[href="${src}"]`))
        return
    const link = document.createElement("link")
    link.setAttribute("rel", "stylesheet")
    link.type = "text/css"
    link.href = src
    documentHead.appendChild(link)
}

export const dateStringToUTC = (dateString: string) => {
    const fragments = dateString.split("-")
    return `${fragments[2]}-${fragments[1]}-${fragments[0]}`
}

export const getScriptSrc = (root: HTMLElement) =>
    (root.querySelector("script") as HTMLScriptElement)
        .getAttribute("src") as string

export const mountComponent = (name, comp, options: { removeInput?: boolean } = {}) => {
    const roots = Array.from(document.querySelectorAll(`[data-comp="${name}"]`)) as HTMLElement[]
    for (const root of roots) {
        try {
            const data = getComponentData(root, options.removeInput)
            m.mount(root, comp(data, root))
            const p = root.parentNode as HTMLElement;
            (Array.from(root.children).reverse())
                .forEach(x => p.insertBefore(x, root))
            p.removeChild(root)
        } catch (err) {
            console.error(err)
            root.innerHTML = `<div class="error"><p>${err.toString()}</p><p>${err.stack}</p></div>`
        }
    }
}

export const priceStringToNumber = (value: string, min: number, max: number) => {
    value = value.replace(",", ".")
    const nValue = parseFloat(value)
    if (isNaN(nValue))
        throw new Error(`${value} is not a number`)
    return Math.max(Math.min(nValue, max), min)
}

export const formatVatNumber = (vatNumber: string) =>
    vatNumber.replace(/\s|\./g, "")

export const mounter = <T extends {}>(selector: string, cb: (root: HTMLElement, data: T | null) => void) =>
    getRootElements(selector)
        .forEach(x => {
            const input = x.querySelector("input")
            let data: any
            try {
                data = input?.value ? JSON.parse(input.value) : null
            } catch (err) {
                data = input.value
            }

            cb(x, data)
        })

export const getFileExt = (str: string) => {
    const a = str.split(".")
    return a[a.length - 1].toLowerCase()
}

export const loadScript = (url: string, target = document.body) =>
    new Promise(r => {
        const tag = document.createElement("script")
        tag.onload = r
        tag.src = url
        target.appendChild(tag)
    })